/* unplugin-vue-components disabled */import script from "./ChannelMockModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChannelMockModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChannelMockModal.vue?vue&type=style&index=0&id=e6e861f8&lang=less"

const __exports__ = script;

export default __exports__